/**
* @ngdoc directive
* @name Week Selector
*
* @description
  Week selector with next/previous, first/last week buttons
*
* @scope
* @param {Boolean} allWeeks - show "all weeks" selection in dropdown
* @param {Boolean} days - show days instead of weeks selector
* @param {Number} daysScreenBreakpoint - breakpoint where selector should start showing days instead of weeks
* @param {Boolean} isEmptyOnInit - optional show empty (choose week) option
*
* @example
  <week-selector
    all-weeks='true'
    days='true'
    days-screen-breakpoint='768'
    is-empty-on-init="true"
  ></week-selector>
*/

(function () {

  app.directive('weekSelector', ["storesPeriodsService", "screenSizeService", "localStorageService", "PATH", "urlRedirectHandlerService", "userDataGAService", function (storesPeriodsService,
    screenSizeService, localStorageService,
    PATH, urlRedirectHandlerService, userDataGAService) {

  return {
    restrict: 'E',
    scope: {
      allWeeks: '=',
      days: '=',
      daysScreenBreakpoint: '=?',
      isEmptyOnInit: '=?'
    },
    templateUrl: PATH.components + 'weekSelector/weekselector.html',
    link: function ($scope) {
      $scope.storesPeriodsService = storesPeriodsService;

      localStorageService.bind($scope, 'userInfo');

      storesPeriodsService.getAvailableWeeks()
        .then(function (data) {
          data = data.data || data;
          storesPeriodsService.availableWeeks = data;
          if (data.length) {
            storesPeriodsService.availableDays = storesPeriodsService.transformIntoDays(data);
            if ($scope.allWeeks) {
              storesPeriodsService.setAllWeeks();
              storesPeriodsService.availableWeeks.unshift(storesPeriodsService.allWeeks);
            }

            if ($scope.days) {
              $scope.daysScreenBreakpoint = $scope.daysScreenBreakpoint || 'sm';
              $scope.shouldShowDays = screenSizeService.smallerThan($scope.daysScreenBreakpoint);
              $scope.onOrientationChange = function () {
                $scope.shouldShowDays = screenSizeService.smallerThan($scope.daysScreenBreakpoint);
                storesPeriodsService.currentPeriod = $scope.shouldShowDays ? storesPeriodsService.currentDay : storesPeriodsService.currentWeek;
              };
            }

            if ($scope.isEmptyOnInit) {
              if ($scope.shouldShowDays) {
                storesPeriodsService.availablePeriods = storesPeriodsService.availableDays;
              } else {
                storesPeriodsService.availablePeriods = storesPeriodsService.availableWeeks;
              }
              return;
            }

            var currentWeek = storesPeriodsService.availableWeeks[0];
            storesPeriodsService.currentWeek = currentWeek;
            var today = moment().format('YYYY-MM-DD');
            storesPeriodsService.currentDay = _.find(storesPeriodsService.availableDays, { 'end':today });
            if ($scope.shouldShowDays) {
              storesPeriodsService.currentPeriod = storesPeriodsService.currentDay;
            } else {
              storesPeriodsService.currentPeriod = storesPeriodsService.currentWeek;
            }
          }
        })
        .then(function() {
          var availablePeriod = [];
          if ($scope.shouldShowDays) {
            availablePeriod = storesPeriodsService.availableDays;
          } else {
            availablePeriod = storesPeriodsService.availableWeeks;
          }
          changeCurrentPeriod(availablePeriod);
        });

      $scope.$watch('storesPeriodsService.currentPeriod', function (period) {
        if (!period) return;
        if (_.find(storesPeriodsService.availableWeeks, period)) {
          storesPeriodsService.availablePeriods = storesPeriodsService.availableWeeks;
          storesPeriodsService.currentWeek = period;
        } else {
          storesPeriodsService.availablePeriods = storesPeriodsService.availableDays;
          storesPeriodsService.currentDay = period;
        }
        storesPeriodsService.checkPeriod(period);
        if (period.start && period.end) {
          userDataGAService.sendGAEvent({
            eventCategory: 'Select by week',
            eventAction: 'selectByWeek',
            eventValue: period.start + ' - ' + period.end,
            additional: true
          });
        }
      });

      $scope.gotoPeriod = function ($event, period) {
        // hack to prevent clashing ov :active state and .disabled class
        $event.preventDefault();
        $event.target.blur();
        if (period === 'next') {storesPeriodsService.nextPeriod();}
        else if (period === 'last'){ storesPeriodsService.lastPeriod();}
        else if (period === 'previous'){ storesPeriodsService.prevPeriod();}
        else if (period === 'first'){ storesPeriodsService.firstPeriod();}
      };

      function changeCurrentPeriod(availablePeriod) {
        _.each(availablePeriod, function(item) {
          if (item.end === urlRedirectHandlerService.getEndDateFormat()) {
            storesPeriodsService.currentPeriod = item;
          }
        });
      }
    }
  };
  }]);
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/weekSelector/weekSelectorDirective.js